import { GetSectionHistoryDocument, OutcomeStatus, SectionReviewState, ValidationStatus } from "generated/graphql";
import { runGqlQuery } from "gqlClient";
import { useAppDispatch } from "redux/hooks";
import {
  updateSectionValueOutcomeAssignee,
  updateSectionValueOutcomeComment,
  updateSectionValueOutcomeStatus,
  updateSectionValuesReviewState,
  updateSectionValueValidationAssignee,
  updateSectionValueValidationComment,
  updateSectionValueValidationStatus,
} from "redux/slices/case";

export function useSectionValue({ caseId, formId }: { caseId: number; formId: number }) {
  const dispatch = useAppDispatch();

  async function updateReviewState(inputs: { sectionId: number; setReviewState: SectionReviewState }[]) {
    return dispatch(updateSectionValuesReviewState({ caseId, formId, inputs })).unwrap();
  }

  async function fetchHistory(sectionId: number) {
    const ret = await runGqlQuery(GetSectionHistoryDocument, { caseId, sectionId, consolidateCommentaries: true });
    return ret.case.formNew.sectionValueHistory
      .reverse()
      .filter(
        (h) =>
          h.changedOutcomeAssignee ||
          h.changedOutcomeComment ||
          h.changedOutcomeStatus ||
          h.changedReviewState ||
          h.changedValidationAssignee ||
          h.changedValidationComment ||
          h.changedValidationStatus ||
          h.outcomeUnassigned ||
          h.validationUnassigned
      );
  }

  async function updateValidationComment(sectionId: number, comment: string) {
    return dispatch(
      updateSectionValueValidationComment({
        caseId,
        sectionId,
        comment,
        formId,
      })
    ).unwrap();
  }

  async function updateOutcomeComment(sectionId: number, comment: string) {
    return dispatch(
      updateSectionValueOutcomeComment({
        caseId,
        sectionId,
        formId,
        comment,
      })
    ).unwrap();
  }

  async function updateValidationStatus(sectionId: number, status: ValidationStatus) {
    return dispatch(
      updateSectionValueValidationStatus({
        caseId,
        sectionId,
        status,
        formId,
      })
    ).unwrap();
  }

  async function updateOutcomeStatus(sectionId: number, status: OutcomeStatus) {
    return dispatch(
      updateSectionValueOutcomeStatus({
        caseId,
        sectionId,
        formId,
        status,
      })
    ).unwrap();
  }

  async function updateValidationAssignee(sectionId: number, assigneeId?: number) {
    return dispatch(
      updateSectionValueValidationAssignee({
        caseId,
        sectionId,
        assigneeId,
        formId,
      })
    ).unwrap();
  }

  async function updateOutcomeAssignee(sectionId: number, assigneeId?: number) {
    return dispatch(
      updateSectionValueOutcomeAssignee({
        caseId,
        sectionId,
        assigneeId,
        formId,
      })
    ).unwrap();
  }

  return {
    updateOutcomeStatus,
    updateValidationStatus,
    updateValidationAssignee,
    updateOutcomeAssignee,
    updateValidationComment,
    updateOutcomeComment,
    updateReviewState,
    fetchHistory,
  };
}
